__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "mycorvinus_shared";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@material-ui/core", "4.12.3", () => (Promise.all([__webpack_require__.e(9068), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(39068))))));
			register("axios", "0.21.4", () => (__webpack_require__.e(9669).then(() => (() => (__webpack_require__(9669))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(3967).then(() => (() => (__webpack_require__(93967))))));
			register("lodash.debounce", "4.0.8", () => (__webpack_require__.e(1296).then(() => (() => (__webpack_require__(91296))))));
			register("oidc-react", "2.1.0", () => (Promise.all([__webpack_require__.e(4776), __webpack_require__.e(2480)]).then(() => (() => (__webpack_require__(24776))))));
			register("react-content-loader", "6.0.3", () => (__webpack_require__.e(4561).then(() => (() => (__webpack_require__(24561))))));
			register("react-cookie-consent", "8.0.1", () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(30143))))));
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(73935))), 1);
			register("react-modal", "3.16.1", () => (Promise.all([__webpack_require__.e(3253), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(83253))))));
			register("react-popper-tooltip", "4.4.2", () => (Promise.all([__webpack_require__.e(3682), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(43682))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(8767), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(88767))))));
			register("react-router-dom", "5.3.0", () => (__webpack_require__.e(3338).then(() => (() => (__webpack_require__(23338))))));
			register("react-select", "4.3.1", () => (Promise.all([__webpack_require__.e(7910), __webpack_require__.e(3390)]).then(() => (() => (__webpack_require__(87910))))));
			register("react", "17.0.2", () => (() => (__webpack_require__(67294))), 1);
			register("recharts", "2.1.6", () => (Promise.all([__webpack_require__.e(1371), __webpack_require__.e(3390), __webpack_require__.e(2335), __webpack_require__.e(328)]).then(() => (() => (__webpack_require__(81371))))));
			register("typesafe-i18n", "2.48.0", () => (__webpack_require__.e(5403).then(() => (() => (__webpack_require__(65403))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};